import { render, staticRenderFns } from "./CentroMenuItem.vue?vue&type=template&id=09a15117"
import script from "./CentroMenuItem.vue?vue&type=script&lang=js"
export * from "./CentroMenuItem.vue?vue&type=script&lang=js"
import style0 from "./CentroMenuItem.vue?vue&type=style&index=0&id=09a15117&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports